import { AxiosService } from './axios.service'
import { SearchService } from './search.service'
import {
	paginationSuccessHandler,
	paginationErrorHandler
} from './pagination-handlers'

/**
 * Defines the API methods for a partner
 */
export class PartnerService extends SearchService {
	static baseURL = 'parceiro'

	/**
	 * Get balance points for Moveflex partner
	 */
	static getBalancePoints() {
		return AxiosService.get(`${this.baseURL}/saldo-de-pontos`).then(
			({ data }) => data.data
		)
	}

	/**
	 * Get sales report
	 * @param {string} DateFilterType
	 * @param {string} DateStart
	 * @param {string} DateEnd
	 * @param {string} PointsStatus
	 * @param {string} TicketStatus
	 * @param {string} Sidx
	 * @param {string} Sord
	 * @param {string} Page
	 * @param {string} RowsPerPage
	 */
	static getTicketSalesReport(params) {
		return AxiosService.get(`parceiro-planalto/relatorios/pesquisar-vendas`, {
			params
		})
			.then(paginationSuccessHandler)
			.catch(paginationErrorHandler)
	}

	/**
	 * Get points extract
	 * @param {string} InitialDate
	 * @param {string} FinalDate
	 * @param {string} Type
	 */
	static getPointsExtract(params) {
		return AxiosService.get(`parceiro/relatorios/extrato-de-pontos`, {
			params
		})
			.then(paginationSuccessHandler)
			.catch(paginationErrorHandler)
	}
}
